<img [src]="data.url" [alt]="data.name" class="attachment-img-preview" />
